import React from "react";
import Header from "../component/Header";
import SubBanner from "../component/SubBanner";
import ResourcesList from "../component/ResourcesList";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../scss/resources.scss";
import "../scss/sub-banner.scss";

function Resources() {
  const { slug } = useParams();
  return (
    <>
      <Helmet>
        <title>Resources | Helpotani</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>

      <main className="resources-page">
        <Header />
        <SubBanner HeaderTitle="Resources" />
        <ResourcesList categorySlug={slug} />
      </main>
      <Footer />
    </>
  );
}
export default Resources;
